import React from "react";
import { useHistory, useLocation } from 'react-router-dom';
import styles from "./TextPage.module.scss";
import About from "content/About";
import ToastInformation from "content/ToastSiteName";

type TextPageProps = {
  page?: string;
  status?: string;
  close?: () => void;
  openTab?: (tabType: string) => void;
};

const TextPage: React.FC<TextPageProps> = ({
  close,
  page,
  openTab,
  status
}) => {
  const history = useHistory();
  const location = useLocation();
  const visible = styles.TextPage + " " + styles.TextPageVisible;
  const hideIt = styles.TextPage + " " + styles.TextPageHidden;
  let textPageClass = null,
    comp = null,
    colorScheme = null,
    closeBtn =
      <div
        className={styles.CloseButton}
        onClick={() => {
          openTab ? openTab("Menu") : location.pathname === '/main' ? history.push('/main') : history.push('/');
        }}
      />


  if (status === "about") {
    textPageClass = visible;
    colorScheme = styles.Grey;
    comp = <About />;
  } else if (status === "toastSiteName") {
    textPageClass = visible;
    colorScheme = styles.darkBlue;
    comp = <ToastInformation />;
    closeBtn = <div
        className={styles.CloseButton}
        onClick={() => {
          openTab ? openTab("AddSite") : history.push('/main');
        }}
      />
  } else {
    textPageClass = hideIt;
    comp = null;
  }

  return (
    <div className={textPageClass + " " + colorScheme}>
      {comp}
      {closeBtn}
    </div>
  );
};

export default TextPage;
